import { REDUCER_NAME } from './constants'

const getInstance = (state, ID) => state[REDUCER_NAME][ID] || {}

export const getFilter = (state, ID) => getInstance(state, ID).filter
export const getFilteredData = (data, filter) => {
  if (!filter) {
    return data
  }

  return data.filter((singleRow) => singleRow.StateID === filter)
}
